function toggleCatalogOpen() {
  $(".email-content").toggleClass("open", true);
}

function toggleCatalogClose() {
  $(".email-content").toggleClass("open", false);
}
export { toggleCatalogOpen, toggleCatalogClose };
